import React from "react";
import isMobile from "ismobilejs";
import { connect } from "react-redux";
import { guardarDatosPersona } from "./flujo.act";
import { callService, formatPhone, formatDate, formatRamo, goTo } from "../tools";
import Modal from '../generalcomponets/modal-mobile';
import DatosForm from "./datos.frm.js";
import DatorFormMovil from "./datosWebMovil.frm";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import { Field, reduxForm } from "redux-form";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import closeIcon from '../img/close-icono.png';
import firebase from 'firebase';
import { servicios } from './../properties';
import axios from 'axios';
import MensajeAyuda from "../modal-ayuda-registro/modal-ayuda-registro.cmpt";

const urlMedios = 'registro.obtenerNombreMedios';
const aplication = 'application/json';
const idModal = "#modal-otp";
var totalSeconds = 420;
const TemporizadoOTP = "TemporizadoOTP";
const validacion = "VALIDACIÓN";
const labelRegInc = false;
const mensajeItim = "Ocurrió un error inesperado, comunícate a la línea GNP 55 5227 9000 para más información.";
let cont = 0;
const modalEnvio = "#modal-nuevo-bloqueado";
const modalEsMorales = "#modal-es-morales";
let contador = 0;

const mapState = (state) => {
	let poliza = state.registro.poliza;
	let vigencia = state.registro.inicioVigenciaPolizaDate;

	if (state.registro.configuracion.poliza_padre) {
		vigencia = state.registro.configuracion.fchVigInicial;
		poliza = state.registro.configuracion.poliza_valida;
		if (poliza === true || poliza === false){
			poliza = state.registro.poliza;
		}
	} else if (state.registro.configuracion.referencia) {
		poliza = state.registro.configuracion.referencia;
	}

	return {
		conectaMovil: state.global.conectaMovil,
		poliza: poliza,
		ramo: state.registro.ramo,
		vigencia: vigencia,
		certificado: state.registro.certificado,
		dispositivo: state.global.dispositivo,
		avisoAceptado: state.registro.avisoAceptado,
		mediosElectronicos: state.registro.mediosElectronicos
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sTitulo, sMensaje, fnClose) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnClose });
		},
		registrarDatos(sEmail, sfechaNacimiento, sfechaNacimientoDate, sLadaFijo, sTelefonoFijo, sLadaMovil, sTelefonoMovil, sApaterno, sAmaterno, sNombres, sRfc) {
			dispatch(guardarDatosPersona(sEmail, sfechaNacimiento, sfechaNacimientoDate, sLadaFijo, sTelefonoFijo, sLadaMovil, sTelefonoMovil, sApaterno, sAmaterno, sNombres, sRfc));
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const campoSettings = { fontFamily: 'Open Sans', fontStyle: 'normal', fontWeight: 'normal', mixBlendMode: 'normal' };
const floatingLabelStyleSettings = { ...campoSettings, lineHeight: '16px', letterSpacing: '0.5px', color: '#0C2040' };
const floatingLabelFocusStyleSettings = { ...campoSettings, lineHeight: '16px', letterSpacing: '0.5px', color: '#FF6B0B' };

const campo = ({ input, label, max, type, focus, error }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={focus}
				onBlur={(event) => { input.onBlur(event); }}
				onChange={(event) => { input.onChange(event); }}
				maxLength={max}
				errorText={error}
				onKeyDown={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress();
					}
				}}
			/>
		</MuiThemeProvider>
	);
};

const handleKeyPress = () => {
	const inputCodigo = document.getElementsByName('codigo_verificacion')[0].value;
	const inputId = document.getElementsByName("codigo_verificacion")[0].id;
	if (inputCodigo.length === 8) {

		document.getElementById(inputId).blur();
		setTimeout(() => {
			document.getElementById("btn-validar").focus();
		}, 10);
	}
}

class Datos extends React.Component {
	mjsError = "No es posible registrarte con una póliza fuera de vigencia. Favor de verificarla.";
	msjFechaNac = "Favor de validar la fecha de nacimiento.";
	rutaAsistido = "gnp/registro-asistido";
	msjErrServicio = "Error Disculpe, ocurrió un error en el servicio, favor de realizar su registro nuevamente.";
	msjDisculpe = "Disculpe, por el momento no es posible completar su registro," +
		" si requieres asistencia comunícate a Línea GNP al 55 5227 9000 opción 7.";
	dataFormulario = {};
	idOperacionOTP = "";
	codigoOtpRecibido = "";
	arrayCodigosOtp = [];
	urlRegistroSeguridad = "";
	errorsCodigo = false;
	msjaMostrar = "";
	btnHabilitado = false;
	celular = "";
	state = {
		isModalOpened: false,
		modalMesage: {
			type: null,
			message: null
		},
		MsjTiempoRestante: true,
		MsjExpira: false,
		msjErrorCodigo: false,
		msjExitoReenvio: false,
		msjErrorServicio: false,
		btnValidarHabilitado: true,
		celular: "",
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
		loadingPequeno: false,
		uidEncriptado: "",
		emailDuplicado: "",
		showModalAyuda: false,
        tipoModalAyuda: ""
	}

	componentDidMount = () => {
		this.labelRegInc = localStorage.getItem("labelRegInc") === "true" ? true : false;

		if (localStorage.getItem("email") === null || localStorage.getItem("cveClienteUnico") === null) {
			localStorage.removeItem("registroAsistido");
		} else {
			this.registroAsistido();
		}
	}

	registroAsistido = () => {
		const datos = { celularAsistido: document.getElementsByName("telefono_movil")[0].value, email: localStorage.getItem("email") };
		this.startTimer();
		this.generarOtp(datos);
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
        const btnAyuda = localStorage.getItem("btnAyuda");

        if(show) {
            if(type === "error" || type === undefined) {
                contador = contador +1;
    
                if(contador <= 2) {
                    setTimeout(() => {
                        this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                    }, 300);
                }
                else {

                    if(btnAyuda !== undefined && btnAyuda === "true"){
                        this.muestraTooltip(false);
                        this.setState({ showModalAyuda: true, tipoModalAyuda: "error"});
                    } else {
                        setTimeout(() => {
                            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                        }, 300);
                    }
                }
            } else {
                setTimeout(() => {
                    this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                }, 300);
            }
        }
    }

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	getHerramienta = () => {
		return (isMobile.any == true) ? "APP" : "PORTAL";
	}

	setDatosPersonales = (data) => {
		localStorage.removeItem("certificadoAzul");
		localStorage.removeItem("certificadoNormal");
		localStorage.setItem("correoObtener", data.email);
		localStorage.setItem("certificadoAzul", this.props.certificado);
		localStorage.setItem("certificadoNormal", this.props.certificado);
		const fNac = data.fechaNacimiento;
		const fechaFormato = fNac.substring(8,10)+"/"+fNac.substring(5,7)+"/"+fNac.substring(0,4);
		localStorage.setItem("fechaNac", fechaFormato);
		cont++;
		let origenP = "true";
		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			console.log(oValue);
			var data = oValue.val();
			if (!data) {
				origenP = "true";
			} else {
				origenP = "false";
			}
		})
		if (cont <= 1) {
			if (localStorage.getItem('fechaNacimientoBMX') !== null || data.fechaNacimiento === '') {
				data.fechaNacimiento = localStorage.getItem('fechaNacimientoBMX');
				if (localStorage.getItem('fechaNac') === "//"){
					const fechaBMX = localStorage.getItem('fechaNacimientoBMX');
					const fechaFormatoBMX = fechaBMX.substring(8,10)+"/"+fechaBMX.substring(5,7)+"/"+fechaBMX.substring(0,4);
					localStorage.setItem("fechaNac", fechaFormatoBMX);
				}
			}

			const $this = this;
			const herramienta = this.getHerramienta();
			const ladaTel = data.telefono_movil.substr(0, 2);
			const telef = data.telefono_movil.substr(2, 8);
			const sistema = localStorage.getItem('sistema');
			$this.props.loader(true);
			$this.props.registrarDatos(
				data.email,
				data.fechaNacimiento,
				data.fechaNacimientoDate,
				data.lada_fijo,
				data.telefono_fijo,
				ladaTel,
				data.telefono_movil,
				data.apaterno,
				data.amaterno,
				data.nombres,
				data.rfc
			);

			new callService({
				service: "registro.datosPersonales",
				secure: true,
				data: {
					ramo: formatRamo(this.props.ramo),
					poliza: this.props.poliza,
					certificado: this.props.certificado,
					vigencia: formatDate(this.props.vigencia),
					email: data.email,
					nacimientoFecha: formatDate(data.fechaNacimiento),
					ladaFijo: formatPhone(data.lada_fijo),
					ladaMovil: ladaTel,
					telefonoFijo: data.telefono_fijo,
					telefonoMovil: telef,
					herramienta: herramienta,
					avisoAceptado: localStorage.getItem("aceptarAviso"),
					mediosElectronicos: localStorage.getItem("mediosElectronicos"),
					sistema: sistema,
					origenapp: 'POR_CL',
					origenPortal: origenP
				}
			}).execute().then((respuesta) => {
				$this.props.loader(false);
				$this.props.tagManager({
					"type": "EVENT_REGISTRO_SIG_DATOS_CORRECTOS_DATOS", "dispositivo": $this.props.dispositivo, "ramo": localStorage.getItem("ramo")
				});
				this.respuestaExitosa(respuesta, data);
				cont = 0;
			}).catch((error) => {
				cont = 0;
				this.setState({ loadingPequeno2: false });
				$this.props.tagManager({
					"type": "EVENT_REGISTRO_SIG_DATOS_INCORRECTOS_DATOS", "dispositivo": $this.props.dispositivo, "ramo": localStorage.getItem("ramo")
				});
				this.errorRespuesta(error);
				localStorage.setItem("email", data.email);
			});
		} else {
			console.log('registro doble');
		}
	}

	respuestaExitosa = (respuesta, data) => {
		const herramienta = this.getHerramienta();

		if (respuesta.registrarClienteResponse.banExito) {
			if (this.props.conectaMovil === true) {
				goTo(respuesta.urlCM);
			} else {
				if (herramienta === "PORTAL") {
					this.urlRegistroSeguridad = respuesta.url.substr(2);
					localStorage.setItem('cveClienteUnico', respuesta.registrarClienteResponse.cveClienteUnico);
					const urlNormal = respuesta.url.substr(2);
					const urlPartida = urlNormal.substr(24);
					const arrayUrl = urlPartida.split("\/");
					const hashOne = arrayUrl[0];
					const hashTwo = arrayUrl[1];
					localStorage.setItem('urlSeguridad', this.urlRegistroSeguridad);
					localStorage.setItem('hashOne', hashOne);
					localStorage.setItem('hashTwo', hashTwo);
					localStorage.setItem('email', data.email);
					localStorage.setItem('telefono', data.telefono_movil);
					localStorage.setItem('fechaNacimiento', data.fechaNacimiento);
					localStorage.setItem('certificado', this.props.certificado);
					localStorage.setItem('poliza', this.props.poliza);
					$(idModal).modal({ backdrop: "static", keyboard: false });
					this.startTimer();
					this.generarOtp(data);
					this.registroInconcluso(respuesta, data);
					this.registroInconclusoPoliza(respuesta, data);
					this.registroBorradoUsuarios(respuesta, data);
				}
				if (herramienta === "APP") {
					goTo(respuesta.url);
				}
			}
		}
	}

	errorRespuesta = (error) => {
		if (error.message.codigoError.includes("ITIM")) {
			this.props.loader(false);
			this.muestraTooltip(true, 'error', validacion, mensajeItim);
		} else if (error.message.codigoError === "REG005" || error.message.codigoError === "REG006") {
			this.props.loader(false);
			this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-REGISTRO-ASISTIDO", "dispositivo": this.props.dispositivo });

			if (this.props.conectaMovil === true) {
				goTo("movil/registro-asistido");
			} else {
				goTo(this.rutaAsistido);
			}
		} else if (error.message.codigoError === "REG004") {
			if (this.props.dispositivo === "app") {
				this.props.loader(false);
				this.openModalParent('error', "Importante", this.msjError);
			} else {
				this.props.loader(false);
				this.muestraTooltip(true, 'error', validacion, this.mjsError);
			}
		} else if (error.message.codigoError === "REG010" || error.message.mensaje.includes("MS o informatica")) {
			this.props.loader(false);
			this.muestraTooltip(true, 'error', validacion, this.msjDisculpe);
		} else if (error.message.codigoError === "REG001") {
			this.props.loader(false);
			this.muestraTooltip(true, 'error', validacion, this.msjErrServicio);
		} else {
			this.errorRespuesta2(error);
		}
	}

	errorRespuesta2 = (error) => {
		if (error.message.codigoError === "REA001") {
			this.props.loader(false);
			this.muestraTooltip(true, 'error', validacion, this.msjFechaNac);
		} else if (error.message.codigoError === "REG001") {
			this.props.loader(false);
			this.muestraTooltip(true, 'error', validacion, this.msjErrServicio);
		} else if (error.message.codigoError === "ecl00062") {
			console.log('Nueva version')
			this.obtenerCorreo();
			this.esMoral();
		} else if (error.message.codigoError === "ecl00100") {
			this.props.loader(false);
			this.muestraTooltip(true, 'error', validacion, this.msjDisculpe);
		} else if (this.props.dispositivo === "app") {
			this.props.loader(false);
			this.openModalParent('error', error.message.mensaje);
		} else {
			if (this.props.dispositivo === "app") {
				this.props.loader(false);
				this.openModalParent('error', error.message.mensaje);
			} else {
				this.props.loader(false);
				this.validacionMensaje(error.message.mensaje);
			}
		}
	}

	esMoral = () => {
		new callService({
			service: "utilerias.detallePoliza",
			secure: false,
			data: { poliza: localStorage.getItem("polizaReal") }
		}).execute().then((oResult) => {
			const llamaServicio = new callService({
				service: "utilerias.clientesMorales",
				secure: false, data: {
					"cveClienteUnico": oResult.contratante.clienteUnico,
					"cifrado": false
				}
			}).execute();
			llamaServicio.then((respuesta) => {
				this.setState({ loading: true });
				console.log("Respuesta", respuesta);
				if (respuesta.moral) {
					console.log("estamos en if respuesta.moral Moral:" + respuesta.moral);
					new callService({
						service: urlMedios,
						"secure": true,
						data: { cveCliente: oResult.contratante.clienteUnico }
					}).execute().then(body => {
						const dominio = body.correo.substring(body.correo.indexOf("@", 0), body.correo.length)
						this.setState({ "emailEsMorales": body.correo + body.correo.substring(body.correo.length - 5, body.correo.length) + dominio });
						$(modalEsMorales).modal({ backdrop: "static", keyboard: true });
					}).catch(error => {
						console.log(error);
					});
				}
			}).catch((error) => {
				if (error.status === 204) {
					this.obtenerCorreo();
				}
				console.log("Error", error);
				this.setState({ loading: false });
			});

		}).catch((error) => {
			console.log("Error", error);
		});


	}

	obtenerCorreo = () => {
		var urlIdentifica = "utilerias.identificaPolizaGrl";
		var existeCertificado = false;
		var certificadoAzul = localStorage.getItem("certificadoAzul");
		const sist = localStorage.getItem('sistema');
		if (certificadoAzul !== null && certificadoAzul !== "" && certificadoAzul !== "00000000"
				&& certificadoAzul !== undefined && sist === "AZUL") {
			existeCertificado = true;
			urlIdentifica = "utilerias.identificaPolizaGrlAzul";
		}
		console.log("EsAzul: ", existeCertificado);
		console.log("Url a la que irá: ", urlIdentifica);
		console.log(formatRamo(this.props.ramo), 'RAMO');
		var sistema = localStorage.getItem('sistema');
		var polizaNum = this.props.poliza;
		console.log(polizaNum);
		console.log(this.props.ramo);
		new callService({
			service: urlIdentifica,
			secure: false,
			data: { numPoliza: this.addZeros(polizaNum, sistema), ramo: formatRamo(this.props.ramo), certificado: certificadoAzul }
		}).execute().then((oResult) => {
			console.log("este es el resultado", oResult);
			this.validacionesUsuario(oResult);
		}).catch((error) => {
			this.props.loader(false);
			console.log("Error", error);
		});
	}

	validacionesUsuario = (oResult) => {
		const fechaIntro = localStorage.getItem("fechaNac");
		var esAsegurado = false;
		if(oResult.asegurados !== null && oResult.asegurados !== undefined){
			for (var i=0; i<oResult.asegurados.length; i++) {
				if (oResult.asegurados[i].fchNacimiento === fechaIntro) {
					esAsegurado = true;
					this.obtenerCorreoReal(oResult.asegurados[i].clienteUnico);
				}
			}
		}
		
		if (esAsegurado === false) {
			console.log("No es un asegurado");
			this.noEsAsegurado(oResult, fechaIntro);
		}
	}

	noEsAsegurado = (oResult, fechaIntro) => {
		console.log("Registro");
		if (oResult.contratante !== null && oResult.contratante.fchNacimiento === fechaIntro) {
			console.log("Reviso si es contratante");
			this.obtenerCorreoReal(oResult.contratante.clienteUnico);
		} else {
			if (oResult.conductor !== null && oResult.conductor.fchNacimiento === fechaIntro) {
				console.log("Reviso si es conductor");
				this.obtenerCorreoReal(oResult.conductor.clienteUnico);
			}
		}
	}

	addZeros = (poliza, sistema) => {
		console.log("esta es la poliza", poliza);
		var complete = poliza;
		console.log('este es el complete', complete);
		if (poliza.length < 14) {
			if(sistema === "AZUL"){
				complete = poliza;
			}else {
				complete = "0000" + poliza;
			}
			console.log('este es el complete dentro el if', complete);
		}
		console.log('retorna', complete);
		return complete;
	}

	obtenerCorreoReal = (cveCliente) => {
		new callService({
			service: urlMedios,
			"secure": true,
			data: { cveCliente: cveCliente }
		}).execute().then(body => {
			var correo = localStorage.getItem("correoObtener");
			console.log("este es el correo a buscar", correo);
			if (body.message === "No existe usuario") {
				this.obtenerNombreMediosCorreo(correo);
			} else {
				this.separaCorreo(body.correo);
			}
		}).catch(error => {
			console.log(error);
			console.log(error.message.mensaje);
			if (error.message.mensaje === "No existe usuario") {
				this.obtenerNombreMediosCorreo(localStorage.getItem("correoObtener"));
			} else {
				console.log("es otro error");
			}
		});
	}

	obtenerNombreMediosCorreo = (correo) => {
		console.log("este es el correo a buscar obtenerNombreMediosCorreo", correo);
		new callService({
			service: urlMedios,
			"secure": true,
			data: { "email": correo }
		}).execute().then(body => {
			console.log(body);
			this.separaCorreo(body.correo);
		}).catch(error => {
			console.log(error);
		});
	}

	registroInconcluso = (respuesta, data) => {
		const bandera = false;
		console.log("respuesta", respuesta.registrarClienteResponse.cveClienteUnico);
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": respuesta.registrarClienteResponse.cveClienteUnico,
				"encripta": true,
			}
		}).then(response => {
			console.log("Antes de incConcluirRegistro", response.data.hash);
			new callService({
				service: "registro.incConcluirRegistro",
				secure: true,
				data: {
					correo: (data.email).toLowerCase(),
					banConcluirReg: bandera,
					path: response.data.hash
				}
			}).execute();
		});
	}

	registroInconclusoPoliza = (respuesta) => {
		const urlNormal = respuesta.url.substr(2);
		const urlPartida = urlNormal.substr(24);
		const arrayUrl = urlPartida.split("\/");
		const hashOne = arrayUrl[1];
		const bandera = false;

		new callService({
			service: "registro.incConluirRegistroPoliza",
			secure: true,
			data: {
				poliza: this.props.poliza,
				certificado: this.props.certificado,
				sistema: localStorage.getItem('sistema'),
				banConcluirReg: bandera,
				path: hashOne
			}
		}).execute();
	}

	registroBorradoUsuarios = (respuesta, data) => {
		new callService({
			service: "registro.datosBorradoUsuarios",
			secure: true,
			data: {
				ramaClave: respuesta.registrarClienteResponse.cveClienteUnico,
				completo: false,
				confidencialidad: false,
				contrato: false,
				email: data.email
			}
		}).execute();
	}

	validacionMensaje(msj) {
		if (msj === 'failed to fetch') {
			this.muestraTooltip(true, 'error', 'ERROR', this.msjErrServicio);
		} else {
			this.muestraTooltip(true, 'error', validacion, this.msjErrServicio);
		}
	}

	submit = (data) => {
		this.setState({ "celular": data.telefono_movil });
		if (localStorage.getItem('cveClienteUnico') !== null && localStorage.getItem('email') !== null &&
			localStorage.getItem('telefono') !== null && localStorage.getItem('fechaNacimiento') !== null) {
			this.validacionFlujo(data);
		} else {
			this.dataFormulario = data;
			this.setDatosPersonales(this.dataFormulario);
		}
	}

	separaCorreo = (email) => {
		this.props.loader(false);
		const dominio = email.substring(email.indexOf("@", 0), email.length)
		email = email.substring(0, email.indexOf("@", 0));
		let element = "";
		for (let index = 0; index < 5; index++) {
			element += '*';
		}
		this.setState({ "emailDuplicado": element + email.substring(5, email.length) + dominio });
		$(modalEnvio).modal({ backdrop: "static", keyboard: true });
	}

	mandaLogin = (ruta) => {
		if (ruta === "login") {
			window.location.href = servicios.dominioReingenieria + "login";
		} else {
			this.cerrarModalDuplicado();
			goTo("gnp/gnp-olvide-contrasenia");
		}
	}

	lineaGNP = () => {
		const link = document.createElement('a');
        link.href = 'tel:5552279000';
        link.click();
		$(modalEnvio).modal('hide');
	}

	cerrarModalDuplicado = () => {
		$(modalEnvio).modal('hide');
	}

	cerrarModalMorales = () => {
		$(modalEsMorales).modal('hide');
	}

	submitMovil = (data) => {
		const $this = this;
		const herramienta = this.getHerramienta();
		const mediosElectronicos = true;
		const sistemaOrigen = localStorage.getItem('sistemaOrigen');
		$this.props.loader(true);
		$this.props.registrarDatos(
			data.email,
			data.fechaNacimiento,
			data.fechaNacimientoDate,
			data.lada_fijo,
			data.telefono_fijo,
			data.lada_movil,
			data.telefono_movil,
			data.apaterno,
			data.amaterno,
			data.nombres,
			data.rfc,
			mediosElectronicos,
			sistemaOrigen
		);
		new callService({
			service: "registro.datosPersonales",
			secure: true,
			data: {
				ramo: formatRamo(this.props.ramo),
				poliza: this.props.poliza,
				certificado: this.props.certificado,
				vigencia: formatDate(this.props.vigencia),
				email: data.email,
				nacimientoFecha: formatDate(data.fechaNacimientoDate),
				ladaFijo: formatPhone(data.lada_fijo),
				ladaMovil: formatPhone(data.lada_movil),
				telefonoFijo: data.telefono_fijo,
				telefonoMovil: data.telefono_movil,
				herramienta: herramienta,
				avisoAceptado: this.props.avisoAceptado,
				mediosElectronicos: mediosElectronicos,
				sistema: sistemaOrigen,
				origenapp: 'POR_CL'
			}
		}).execute().then((respuesta) => {
			$this.props.loader(false);
			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-DATOS-CORRECTOS", "dispositivo": $this.props.dispositivo });
			if (respuesta.registrarClienteResponse.banExito) {
				if ($this.props.conectaMovil === true) {
					goTo(respuesta.urlCM);
				} else {
					if (herramienta === "PORTAL") {
						goTo("gnp/registro-completo");
					}
					if (herramienta === "APP") {
						goTo(respuesta.url);
					}
				}
			}
		}).catch((error) => {
			$this.props.loader(false);
			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-DATOS-INCORRECTOS", "dispositivo": $this.props.dispositivo });

			if (error.message.codigoError.includes("ITIM")) {
				this.muestraTooltip(true, 'error', validacion, mensajeItim);
			} else if (error.message.codigoError === "REG005" || error.message.codigoError === "REG006") {
				$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-REGISTRO-ASISTIDO", "dispositivo": $this.props.dispositivo });

				if ($this.props.conectaMovil === true) {
					goTo("movil/registro-asistido");
				} else {
					goTo("gnp/registro-asistido");
				}
			} else if (error.message.codigoError === "REG004") {
				if (this.props.dispositivo === "app") {
					this.openModalParent('error', "Importante", this.msjError);
				} else {
					$this.props.alerta("Importante", this.msjError);
				}

			} else {
				if (this.props.dispositivo === "app") {
					this.openModalParent('error', error.message.mensaje);
				} else {
					this.muestraTooltip(true, 'error', validacion, this.msjErrServicio);
				}
			}
		});
	}

	validacionFlujo = (data) => {
		if (this.validacionFlujoSeguridad(data)) {
			goTo(localStorage.getItem('urlSeguridad'));
		} else if (this.validacionFlujoActualizarDatos(data)) {
			this.setActualizaDatosPersonales(data);
		} else if (this.validacionDatosPersonales(data)) {
			console.log('aqui va a datos personales 1 vez envalidacion flujo');
			this.setDatosPersonales(data);
		} else if (localStorage.getItem('email') === data.email && localStorage.getItem('telefono') === data.telefono_movil &&
			localStorage.getItem('fechaNacimiento') === data.fechaNacimiento && localStorage.getItem('validoOTP') === null) {
			$(idModal).modal({ backdrop: "static", keyboard: true });
			this.startTimer();
			this.generarOtp(data);
		} else {
			console.log('ocurrio algo en validaciones')
		}
	}

	validacionFlujoSeguridad = (data) => {
		if (localStorage.getItem('email') === data.email && localStorage.getItem('telefono') === data.telefono_movil &&
			localStorage.getItem('fechaNacimiento') === data.fechaNacimiento && localStorage.getItem('validoOTP') !== null) {
			return true;
		} else {
			return false
		}
	}

	validacionFlujoActualizarDatos = (data) => {
		if ((localStorage.getItem('email') !== data.email || localStorage.getItem('telefono') !== data.telefono_movil) &&
			localStorage.getItem('fechaNacimiento') === data.fechaNacimiento) {
			return true;
		} else {
			return false;
		}
	}

	validacionDatosPersonales = (data) => {
		if ((localStorage.getItem('email') === data.email && localStorage.getItem('telefono') === data.telefono_movil) &&
			localStorage.getItem('fechaNacimiento') !== data.fechaNacimiento &&
			(localStorage.getItem('validoOTP') === null || localStorage.getItem('validoOTP') !== null)) {
			return true;
		} else {
			return false;
		}
	}

	setActualizaDatosPersonales = (data) => {
		localStorage.removeItem('email');
		localStorage.removeItem('telefono');
		localStorage.removeItem('fechaNacimiento');
		this.props.loader(true);
		const ladaTel = data.telefono_movil.substr(0, 2);
		const telef = data.telefono_movil.substr(2, 8);
		this.props.registrarDatos(
			data.email,
			data.fechaNacimiento,
			data.fechaNacimientoDate,
			data.lada_fijo,
			data.telefono_fijo,
			ladaTel,
			telef,
			data.apaterno,
			data.amaterno,
			data.nombres,
			data.rfc
		);
		new callService({
			service: "miPerfil.actualizarMedios",
			secure: true,
			data: {
				clienteUnico: localStorage.getItem('cveClienteUnico'),
				correo: data.email,
				telefonos: [{
					lada: ladaTel,
					numero: telef,
					cveTipoContacto: "TLCL"
				}]
			}
		}).execute().then((respuesta) => {
			this.props.loader(false);
			this.urlRegistroSeguridad = localStorage.getItem('urlSeguridad');
			localStorage.setItem('email', data.email);
			localStorage.setItem('telefono', data.telefono_movil);
			localStorage.setItem('fechaNacimiento', data.fechaNacimiento);
			$(idModal).modal({ backdrop: "static", keyboard: false });
			this.startTimer();
			this.generarOtp(data);
		}).catch((error) => {
			this.props.loader(false);
			$(modalEnvio).modal({ backdrop: "static", keyboard: true });
			setTimeout(() => {
				this.muestraTooltip(false);
			}, 3000);
		});

	}

	openModalParent = (type, title, message) => {
		const { isModalOpened } = this.state;
		if (isModalOpened) {
			this.setState({ isModalOpened: false, modalMesage: { type: null, title: null, message: null } })
		} else {
			this.setState({ isModalOpened: true, modalMesage: { type, title, message } });
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false, modalMesage: { type: null, message: null } })
	}

	generarOtp = (data) => {
		this.celularValor(data);
		this.quitarMsjErrorCodigo(false);
		this.quitarmsjErrorServicio(false);
		this.quitarMsjExpiro(false);
		this.btnHabilitado = false;
		this.quitarMsjTiempoRestante(true);
		document.getElementsByName('codigo_verificacion')[0].value = "";

		new callService({
			service: 'otp.obtenerOtpBan',
			"secure": true,
			data: { clienteUnico: localStorage.getItem("cveClienteUnico") }
		}).execute().then(body => {
			if (body.enviarOtpResponse.resultado) {
				this.idOperacionOTP = body.enviarOtpResponse.idOperacion;
				this.codigoOtpRecibido = body.enviarOtpResponse.codOtp;
			} else {
				console.log('error');
			}
		}).catch(error => {
			this.quitarmsjErrorServicio(true);
		});
		setTimeout(() => {
			this.props.loader(false);
		}, 4000);
	}

	celularValor = (data) => {
		if (data.celularAsistido !== "" || data.celularAsistido !== null || data.celularAsistido !== undefined) {
			this.state.celular = data.celularAsistido;
			setTimeout(() => {
				$(idModal).modal({ backdrop: "static", keyboard: false });
			}, 1000);
		}
		if (this.state.celular) {
			this.celular = this.state.celular;
		} else if (data.ladaCelular && data.telCelular) {
			this.celular = data.ladaCelular + data.telCelular;
		} else {
			this.celular = data.telefono_movil;
		}
	}

	validarCodOtp = () => {
		this.props.loader(true);
		this.quitarMsjErrorCodigo(false);
		this.quitarMsjExpiro(false);
		this.quitarmsjErrorServicio(false);
		const codigo = document.getElementsByName('codigo_verificacion')[0].value;

		if (this.arrayCodigosOtp.length > 0 && this.arrayCodigosOtp.includes(codigo)) {
			this.props.loader(false);
			this.quitarMsjErrorCodigo(true);
			this.quitarMsjExpiro(false);
		} else {
			new callService({
				service: "registro.validarOtpBanRegistro",
				secure: true,
				data: { codigo: codigo, operacion: this.idOperacionOTP },
			}).execute().then(body => {
				this.props.loader(false);
				this.respuestaValidarOtp(body);
			}).catch(error => {
				this.props.loader(false);
				this.quitarMsjExpiro(false);
			});
		}
	}

	respuestaValidarOtp = (body) => {
		const banConcluirRegPoliza = localStorage.getItem("banConcluirRegPoliza");
		const banConcluirReg = localStorage.getItem("banConcluirReg");
		const codigo = document.getElementsByName('codigo_verificacion')[0].value;
		if (body.error && this.codigoOtpRecibido === codigo) {
			this.quitarMsjExpiro(true);
			this.quitarMsjErrorCodigo(false);
		} else if (body.error && this.codigoOtpRecibido !== codigo) {
			this.quitarMsjExpiro(false);
			this.quitarMsjErrorCodigo(true);
		} else if (!body.error && body.tipo === 'exito') {
			localStorage.setItem('validoOTP', 'true')
			$(idModal).modal('hide');
			this.registroInconclusoFlujo(banConcluirReg, banConcluirRegPoliza);
			if (banConcluirReg === "false" || banConcluirRegPoliza === "false") {
				const path = localStorage.getItem("hashOne");
				this.correoEncriptado(path);
			} else {
				goTo(this.urlRegistroSeguridad);
			}
		} else {
			console.log('error')
		}
	}

	registroInconclusoFlujo = (banConcluirReg, banConcluirRegPoliza) => {
		if (banConcluirReg === "false" || banConcluirRegPoliza === "false") {
			const path = localStorage.getItem("hashOne");
			this.correoEncriptado(path);
		} else {
			if (localStorage.getItem("registroAsistido") && (localStorage.getItem("registroAsistido") !== "false"
				|| localStorage.getItem("registroAsistido") !== undefined)) {
				this.urlRegistroSeguridad = localStorage.getItem('urlSeguridad').substr(2);
				goTo(this.urlRegistroSeguridad);
			} else {
				goTo(this.urlRegistroSeguridad);
			}
		}
	}

	correoEncriptado = (uidEncriptado) => {
		const correo = document.getElementsByName("email")[0].value;
		new callService({
			service: "registro.obtenerurlregistro",
			secure: false,
			data: { valor: correo }
		}).execute().then(resp => {
			localStorage.setItem("email", correo);
			axios({
				method: 'POST',
				url: servicios.utilerias.actualizaNodoRestablecer,
				headers: {
					'Content-Type': aplication,
					'Access-Control-Allow-Origin': '*',
					"valor": "POR_CL",
					"encripta": false
				}
			}).then(response => {

				goTo(`gnp/registro-seguridad/${uidEncriptado}/${resp.hash}/${response.data.hash}`);
			});

		}).catch(error => {
			console.log("error al encriptar el valor correo", error);
		});
	}

	reenviarOtp = () => {
		this.arrayCodigosOtp.push(this.codigoOtpRecibido);
		this.mostrarSpinner(true);
		this.quitarmsjErrorServicio(false);
		new callService({
			service: 'otp.obtenerOtpBan',
			"secure": true,
			data: { clienteUnico: localStorage.getItem('cveClienteUnico') }
		}).execute().then(body => {
			this.idOperacionOTP = "";
			this.codigoOtpRecibido = "";
			if (body.enviarOtpResponse.resultado) {
				this.idOperacionOTP = body.enviarOtpResponse.idOperacion;
				this.codigoOtpRecibido = body.enviarOtpResponse.codOtp;
				this.mostrarSpinner(false);
				this.quitarmsjReenvio(true);
				this.resetTimer();
			} else {
				this.mostrarSpinner(false);
			}
		}).catch(error => {
			this.mostrarSpinner(false);
			this.quitarmsjErrorServicio(true);
		});
	}

	quitarMsjTiempoRestante = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ MsjTiempoRestante: bandera })
			}, 100);
		} else {
			this.setState({ MsjTiempoRestante: bandera })
		}
	}

	quitarMsjExpiro = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ MsjExpira: bandera })
			}, 1000);
		} else {
			this.setState({ MsjExpira: bandera })
		}
	}

	quitarMsjErrorCodigo = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjErrorCodigo: bandera })
			}, 1000);
		} else {
			this.setState({ msjErrorCodigo: bandera })
		}
	}

	quitarmsjReenvio = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjExitoReenvio: true })
			}, 500);
		} else {
			setTimeout(() => {
				this.setState({ msjExitoReenvio: false })
			}, 500);
		}
	}

	quitarmsjErrorServicio = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjErrorServicio: bandera })
			}, 500);
		} else {
			this.setState({ msjErrorServicio: bandera })
		}
	}

	mostrarSpinner = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ loadingPequeno: true });
			}, 500);
		} else {
			setTimeout(() => {
				this.setState({ loadingPequeno: false });
			}, 500);
		}
	}

	codigoCompleto = () => {
		const inputCodigo = document.getElementsByName('codigo_verificacion')[0].value;
		if (/^[0-9]+/.test(inputCodigo) && inputCodigo.length === 8) {
			this.msjaMostrar = "";
			this.errorsCodigo = false;
			this.setState({ btnValidarHabilitado: false })
		} else {
			console.log("else otp");
		}
	}

	pruebaInconcluso = (data) => {
		this.generarOtp(data);
		this.startTimer();
		$(idModal).modal({ backdrop: "static", keyboard: false });
	}

	startTimer = () => {
		if (!this.interval) {
			function pad(val) {
				return val > 9 ? val : "0" + val;
			}

			this.interval = setInterval(function () {
				totalSeconds -= 1;
				if (totalSeconds > 0) {
					document.getElementById(TemporizadoOTP).innerText =
						'Válido por ' + pad(Math.floor(totalSeconds / 60 % 60)) + ":" + pad(parseInt(totalSeconds % 60)) + ' minutos';
				} else {
					document.getElementById(TemporizadoOTP).innerText = 'Válido por 00:00 minutos';
				}
			}, 1000);
		}
	}

	resetTimer = () => {
		totalSeconds = 420;
		clearInterval(this.interval);
		document.getElementById(TemporizadoOTP).innerText = "";
		delete this.interval;
		this.startTimer();
	}

	cerrarModal = () => {
		$(idModal).modal('hide');
		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			var data = oValue.val();
			if (!data) {
				goTo("login");
			} else {
				window.location.assign(servicios.dominioReingenieria);
			}
		})
	}

	cierraTooltip2 = e => {
        this.setState({
            showModalAyuda:!this.state.showModalAyuda 
        });
    }

	maskNumber = (num) => {
        return '(+' + num.substring(0, 2) + ') ******' + num.substring(num.length - 4, num.length);
    }
    
    maskEmail = (email) => {
        if (email) {
            const dominio = email.split('@');
            const pad = dominio[1].length > 3 ? dominio[1].length - 3 : 3;
            let mask = '';
            for (let i = 0; i < pad; i++) {
                mask += '*';
            }
            const dominioLength = dominio[0].length;
            dominio[0] =
                dominioLength > 3
                    ? dominio[0].substring(dominioLength - 3)
                    : dominio[0].substring(dominioLength - 1);
            return mask + dominio[0] + '@' + dominio[1];
        }
        return '***********@****.**';
    }

	render() {
		const modalOtp = "modal-otp";
		const codVerif = "Código de verificación";
		const email = this.emailRegistro ? this.maskEmail(this.emailRegistro) : "";
        const celular = this.celular ? this.maskNumber(this.celular) : "";
		
		return (
			<div>
				{this.props.dispositivo === "web" ? <DatosForm onSubmit={this.submit} registroInconcluso={this.pruebaInconcluso} /> :
					<DatorFormMovil onSubmit={this.submitMovil} />}
				{this.state.isModalOpened && <Modal closeModalFromChild={this.closeModalFromChild}>
					<div className="container">
						<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
								{this.state.modalMesage.type === "error" && <img src={require('../img/warning-new-style.svg')} alt="Error image modal" className="gnp-material-comtent-image" />}
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
								<label className="gnp-material-title-modal">{this.state.modalMesage.title}</label>
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
								<p className=" gnp-material-content-modal">{this.state.modalMesage.message}</p>
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
								<button type="button" onClick={this.closeModalFromChild} className="pure-material-button-contained btn-full-width">Aceptar</button>
							</div>
						</div>
					</div>
				</Modal>}

				<MensajeAyuda onClose={this.cierraTooltip2} show={this.state.showModalAyuda} typeModal={this.state.tipoModalAyuda}></MensajeAyuda>

				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>

				<div className="modal fade" id={modalOtp} tabIndex="-1" role="dialog" aria-labelledby={modalOtp}>
					<div className="modal-dialog modal-otp modal-otp-2" id="modal-otp" role="document">
						<div className="modal-content modal-content-otp modal-content-otp-2">
							<span id="icon-equis-cerrar" onClick={this.cerrarModal}>X</span>
							<div className="modal-header-otp modal-header-otp-2">
								<h4 id={modalOtp} className="otp-titulo">{codVerif}</h4>
							</div>
							<div className="modal-body-otp modal-body-otp-2">
								<div className="modal-body-otp-title modal-body-otp-title-2">
								<label>{labelRegInc ? "Registro inconcluso !" : ""}Ingresa el código de verificación que enviamos a tu correo electrónico: </label>
                                    <label style={{ marginTop: "8px", "color": "#ff6b0b" }}>
                                        {email}
                                    </label>
                                    <br/>
                                    <label>y por SMS al número:</label>
                                    <br/>
                                    <label style={{ marginTop: "8px", "color": "#ff6b0b" }}>
                                        {celular}
                                    </label>
									<div className="input-wrap input-otp input-otp-2">
										<Field
											label={codVerif}
											name="codigo_verificacion" component={campo} type="text" max="8"
											onChange={this.codigoCompleto.bind(this)}
											error={this.errorsCodigo ? this.msjaMostrar : null}
										/>
									</div>
									{this.state.MsjTiempoRestante ?
										<div className="alerta-otp alerta-otp-2">
											<div> <span className="icon-warning"></span> </div>
											<div className="alerta-body">
												<label className="label-title-alerta">{codVerif}</label>
												<label className="label-text-alerta" id={TemporizadoOTP}></label>
											</div>
											<div>
												<span className="icon-equis" style={{ 'cursor': 'pointer' }} onClick={this.quitarMsjTiempoRestante.bind(this, false)}></span>
											</div>
										</div> : null}
									{this.state.MsjExpira ?
										<div className="alerta-otp" style={{ "background": "#FDF3F5", "height": "auto" }}>
											<div>
												<span className="icon-equis-circulo" style={{ 'cursor': 'pointer' }} onClick={this.quitarMsjExpiro.bind(this, false)}></span>
											</div>
											<div className="alerta-body">
												<label className="label-title-alerta-error">{codVerif}</label>
												<label className="label-text-alerta">El código de verificación ha expirado, intente nuevamente</label>
											</div>
										</div> : null}
									{this.state.msjErrorServicio ?
										<div className="alerta-otp" style={{ "background": "#FDF3F5", "height": "auto" }}>
											<div>
												<span className="icon-equis-circulo" style={{ 'cursor': 'pointer' }} onClick={this.quitarmsjErrorServicio.bind(this, false)}></span>
											</div>
											<div className="alerta-body">
												<label className="label-title-alerta-error">Error</label>
												<label className="label-text-alerta">Ocurrio un error, intente más tarde.</label>
											</div>
										</div> : null}
									{this.state.msjErrorCodigo ?
										<div className="alerta-otp" style={{ "background": "#FDF3F5", "height": "auto" }}>
											<div>
												<span className="icon-equis-circulo" style={{ 'cursor': 'pointer' }} onClick={this.quitarMsjErrorCodigo.bind(this, false)}></span>
											</div>
											<div className="alerta-body">
												<label className="label-title-alerta-error">Error</label>
												<p>
													<label className="label-text-alerta">El código de verificación no coincide.</label>
												</p>
											</div>
										</div> : null}
									{this.state.msjExitoReenvio ?
										<div className="alerta-otp" style={{ height: 'auto', background: '#E3F5EB' }}>
											<div> <span className="icon-circle-dove" style={{ margin: '25px 8px' }}></span> </div>
											<div className="alerta-body">
												<label className="label-title-alerta" style={{ color: '#44956C' }}>CÓDIGO REENVIADO</label>
												<label className="label-text-alerta">Se ha reenviado el código exitosamente.</label>
											</div>
											<div>
												<span className="icono-cerrar-sintillo" style={{ 'cursor': 'pointer', color: '#44956C !important' }}
													onClick={this.quitarmsjReenvio.bind(this, false)}></span>
											</div>
										</div> : null}
									<div className="footer-modal-otp">
										<label>¿Tienes problemas? <span style={{ "color": "#ff6b0b", 'cursor': 'pointer' }}
											onClick={this.reenviarOtp.bind(this)}>
											Reenviar código</span>
											{this.state.loadingPequeno ? <div className="spinner" style={{ position: "absolute", right: '20px', marginTop: '-22px' }}
												id="spinner-validacion-poliza"></div> : null}
										</label>
										<div className="boton-text-final-otp">
											<button
												id="btn-validar"
												disabled={this.state.btnValidarHabilitado}
												style={{ "color": "#FFFFFF" }} type="button"
												className=" orange-btn texto-otp orange-btn-otp"
												onClick={this.validarCodOtp.bind(this)}
											>Validar</button>
											<span className="texto-otp"
												style={{ "color": "#FF6B0B", 'cursor': 'pointer', marginLeft: '23px' }}
												data-dismiss="modal">
												No es mi número actual
											</span>
										</div>
									</div>
									<br />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="modal modal-msj fade" id="modal-nuevo-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel"
					data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog" role="document">
						<div className="modal-content" style={{ width: '90%', margin: '50px' }}>
							<div style={{ width: '100%' }}>
								<img src={closeIcon} style={{ position: 'absolute', top: '0', right: '0' }}
									id="icon-close" onClick={this.cerrarModalDuplicado} />
							</div>
							<div className="modal-cabecera" style={{ textAlign: 'center', marginTop: '24px', marginBottom: '20px' }}>

								<label className="cargaMasivaTituloModal" id="modal-nuevo-bloqueadoLabel">Cliente Registrado</label>
							</div>
							<div style={{ marginLeft: '17px' }}>
								<p className="letra-Modal-RegistroDuplicado">
									Ya tienes una cuenta con el correo {this.state.emailDuplicado}
								</p>
								<p className="letra-Modal-RegistroDuplicado">
									Inicia sesión con tus datos registrados o recupera tu contraseña;
									si requieres modificar el correo electrónico comunicate a la Línea GNP opción 7.
								</p>
							</div>
							<div className="mt-20 opciones-bloqueo">
								<div>
									<button type="button" className="btn-Modal-RegistroDuplicadoIniciaSes"
										onClick={this.mandaLogin.bind(this, 'login')}>Iniciar sesión</button>
								</div>
								<div>
									<button type="button" className="btn-Modal-RegistroDuplicado"
										onClick={this.mandaLogin.bind(this, 'gnp-olvide-contrasenia')}>Recuperar Contraseña</button>
								</div>
								<div>
									<button type="button" className="btn-Modal-RegistroDuplicado2"
										onClick={this.lineaGNP}>Línea GNP</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="modal modal-msj fade" id="modal-es-morales" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel"
					data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog" role="document">
						<div className="modal-content" style={{ width: '90%', margin: '50px' }}>
							<div style={{ width: '100%' }}>
								<img src={closeIcon} style={{ position: 'absolute', top: '0', right: '0' }}
									id="icon-close" onClick={this.cerrarModalMorales} />
							</div>
							<div className="modal-cabecera" style={{ textAlign: 'center', marginTop: '24px', marginBottom: '20px' }}>

								<label className="cargaMasivaTituloModal" id="modal-es-morales">Cliente Registrado en el portal empresarial</label>
							</div>
							<div style={{ marginLeft: '17px' }}>
								<p className="letra-Modal-RegistroDuplicado">
									Ya tienes una cuenta con el correo {this.state.emailEsMorales} en el portal empresarial
								</p>
								<p className="letra-Modal-RegistroDuplicado">
									Inicia sesión con tus datos registrados en el portal empresarial o recupera tu contraseña;
									Y ocupe la funcionalidad de agregar poliza. Si requieres modificar el correo electrónico comunicate a la Línea GNP opción 7.
								</p>
							</div>
							<div className="text-center aceptar-cancelar-btn mt-20 opciones-bloqueo"
								style={{ width: '270px', height: '31px', marginTop: '45px' }}>
								<div>
									<button type="button" className="btn-Modal-RegistroDuplicadoIniciaSes"
										style={{ position: 'absolute', width: '40% !important', left: '17px' }}
										onClick={this.mandaLogin.bind(this, 'login')}>Iniciar sesión</button>
								</div>
								<div>
									<button type="button" className="btn-Modal-RegistroDuplicado"
										style={{ position: 'absolute', left: '50%', width: '47%' }}
										onClick={this.mandaLogin.bind(this, 'gnp-olvide-contrasenia')}>Recuperar Contraseña</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
Datos = reduxForm({ form: "registro-datos" })(Datos);
export default connect(mapState, mapDispatch)(Datos);



// WEBPACK FOOTER //
// ./src/gnp-registro/datos.cmpt.js